import { Category } from '../WaysToTour';

export const categorySort = (arr: Category[] | undefined) => {
    if (arr && arr.length > 0) {
        arr.sort((a: { display_name: string }, b: { display_name: string }) => {
            if (a.display_name > b.display_name) {
                return 1;
            } else if (a.display_name < b.display_name) {
                return -1;
            }
            return 0;
        });
    }
    return 0;
};
